import { takeEvery, put } from 'redux-saga/effects';

import { API_CALL } from '../actionTypes/sharedActions';
import { GET_RESTAURANT_MEALS } from '../routes';
import restaurantMealsActions from '../actionTypes/restaurantMealsActions';

function* getRestaurantMeals({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: GET_RESTAURANT_MEALS,
      method: 'GET',
      data: payload,
      params: payload
    },
    successAction: restaurantMealsActions.getRestaurantMealsSuccess,
    failureAction: restaurantMealsActions.getRestaurantMealsFailed
  });
}

export default function* watchRestaurantMeals() {
  yield takeEvery(
    restaurantMealsActions.getRestaurantMeals,
    getRestaurantMeals
  );
}
